import { useEffect } from 'react'

export function usePreventIosAutoZoom() {
  useEffect(() => {
    if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
      const viewportEl = document.querySelector('[name=viewport]')
      if (viewportEl) {
        viewportEl.setAttribute(
          'content',
          'width=device-width, initial-scale=1, maximum-scale=1',
        )
      }
    }
  }, [])
}
